import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { SpinnerOverlayService } from "../services/loading.service";

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private readonly spinnerOverlayService: SpinnerOverlayService) {}

  /**
   * Mantiene el overlay para operaciones normales y permite que el sondeo
   * silencioso de mantenimiento se ejecute sin parpadear cada minuto.
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has("X-Skip-Loading")) {
      return next.handle(req.clone({
        headers: req.headers.delete("X-Skip-Loading"),
      }));
    }
    const spinnerSubscription: Subscription =
      this.spinnerOverlayService.spinner$.subscribe();
    return next
      .handle(req)
      .pipe(finalize(() => spinnerSubscription.unsubscribe()));
  }
}
